import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "button"]
  static classes = ["clamp"]

  connect() {
    this.#updateButtonVisibility()
  }

  #updateButtonVisibility() {
    if (this.textTarget.scrollHeight > this.textTarget.clientHeight) {
      this.buttonTarget.classList.remove("d-none")
    }
  }

  toggle() {
    this.textTarget.classList.toggle(this.clampClass)
    if (this.textTarget.classList.contains(this.clampClass)) {
      this.textTarget.classList.remove("d-inline-block")
      this.buttonTarget.textContent = "Read more"
    } else {
      this.textTarget.classList.add("d-inline-block")
      this.buttonTarget.textContent = "Read less"
    }
  }
}
